// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary-1D121","label":"label-2TZ_S","main":"main-3cAAD","active":"active-3D7Gt"};